<div class="navigation-header" id="nav-bar-container">
  <a class="navigation-header__mobile-logo" [href]="logoHref" aria-label="Go to home">
    <img [src]="logoSrc" width="80" height="28" alt="" aria-hidden="true">
  </a>

  @if (showSearch) {
    <ngf-tester-navigation-header-search
      [searchQuery]="searchQuery"
      (searchSubmit)="searchSubmit.emit($event)">
    </ngf-tester-navigation-header-search>
  }
  <div class="navigation-header__actions">
    <ngf-tester-navigation-header-support></ngf-tester-navigation-header-support>
    <ngf-tester-navigation-header-chat></ngf-tester-navigation-header-chat>
    @if (showNotifications) {
      <ngf-tester-navigation-header-notifications
        [notificationsUrl]="notificationsUrl">
      </ngf-tester-navigation-header-notifications>
    }
    <ngf-tester-navigation-header-account></ngf-tester-navigation-header-account>
  </div>

  @if ((mobileMenuService.isOpen$ | async) === false) {
    <div class="navigation-header__mobile-actions">
      @if (showSearch) {
        <button type="button" class="navigation-header__mobile-btn"
          [attr.aria-label]="searchOpen ? 'Close search' : 'Search'"
          [attr.aria-expanded]="searchOpen"
          (click)="toggleSearch()">
          @if (!searchOpen) {
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M21 21L15.0001 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          } @else {
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          }
        </button>
      }
      <button type="button" class="navigation-header__mobile-btn" aria-label="Open navigation menu" (click)="mobileMenuService.toggle()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M3 12H15M3 6H21M3 18H21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  }

  @if (searchOpen) {
    <div class="navigation-header__mobile-search-panel">
      @if (showSearch) {
        <ngf-tester-navigation-header-search
          [searchQuery]="searchQuery"
          (searchSubmit)="onMobileSearch($event)">
        </ngf-tester-navigation-header-search>
      }
    </div>
  }
</div>

@if (searchOpen) {
  <div class="navigation-header__search-overlay" aria-hidden="true"></div>
}
